import React, { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import './App.css';
import "react-tippy/dist/tippy.css";
import MiniDrawer from './Pages/sideDrawer.js';
import SignIn from "./Pages/signin.js";
import SignUp from "./Pages/signup.js";
import ResetPassword from "./Pages/ResetPassword.js";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "./Pages/Header.js";
import { useTheme } from "@mui/material/styles";
import GuestUserForm from "./Pages/guestUserForm.js";
import GuestUserScreen from "./Pages/GuestUserScreen.js";
import VendorWelcome from "./Pages/VendorWelcome.js";
import VendorLayout from "./components/VendorLayout.js";
import VendorRoute from "./components/VendorRoute.js";
import { getPostLoginPath, getTokenPayload, isVendorUser } from "./utils/auth.js";

const PUBLIC_PATHS = ['/signin', '/create-new-account', '/create-new-password', '/'];

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem('access-token');
  const isVendor = isAuthenticated && isVendorUser();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const path = location.pathname;
    if (!isAuthenticated && !PUBLIC_PATHS.includes(path)) {
      navigate('/signin');
      return;
    }
    if (isAuthenticated && isVendorUser() && !path.startsWith('/vendor')) {
      navigate('/vendor/home', { replace: true });
      return;
    }
    if (isAuthenticated && !isVendorUser() && path.startsWith('/vendor')) {
      navigate('/home', { replace: true });
    }
  }, [isAuthenticated, location.pathname, navigate]);

  useEffect(() => {
    if (isAuthenticated && PUBLIC_PATHS.includes(location.pathname)) {
      const payload = getTokenPayload();
      navigate(getPostLoginPath(payload), { replace: true });
    }
  }, [isAuthenticated, location.pathname, navigate]);

  return (
    <div>
      {isAuthenticated && isVendor && <VendorLayout />}
      {isAuthenticated && !isVendor && (isMobile ? <Header /> : <MiniDrawer />)}
      <div className="">
        <React.Suspense fallback={null}>
          <Routes>
            {!isAuthenticated && (
              <>
                <Route path="/create-new-password" element={<ResetPassword />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/create-new-account" element={<SignUp />} />
                <Route path="/" element={<SignIn />} />
                <Route path="/guest-user" element={<Navigate to="/signin" replace />} />
                <Route path="/guest-user-form" element={<Navigate to="/signin" replace />} />
                <Route path="*" element={<Navigate to="/signin" replace />} />
              </>
            )}
            {isAuthenticated && isVendor && (
              <>
                <Route
                  path="/vendor/home"
                  element={
                    <VendorRoute>
                      <VendorWelcome />
                    </VendorRoute>
                  }
                />
                <Route
                  path="/vendor/orders"
                  element={
                    <VendorRoute>
                      <GuestUserScreen />
                    </VendorRoute>
                  }
                />
                <Route
                  path="/vendor/create-order"
                  element={
                    <VendorRoute>
                      <GuestUserForm />
                    </VendorRoute>
                  }
                />
                <Route path="/guest-user" element={<Navigate to="/vendor/home" replace />} />
                <Route path="/guest-user-form" element={<Navigate to="/vendor/create-order" replace />} />
                <Route path="*" element={<Navigate to="/vendor/home" replace />} />
              </>
            )}
            {isAuthenticated && !isVendor && (
              <Route path="*" element={null} />
            )}
          </Routes>
        </React.Suspense>
      </div>
    </div>
  );
}

export default App;
